<div class="modal-header bg-light">
    <div class="modal-title pull-left">
        <h3 class="mb-0 font-weight-bold">External answers request</h3>
    </div>

    <button id="external-ans-close" type="button" class="close pull-right align-self-center" aria-label="Close" (click)="decline()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-light">
    <div class="text-center">
        <div class="title__text">
            Copy and send the link to the person, you want to answer the questions
        </div>
        <div>
            <button id="external-copy-link-btn" class="button primary__button medium__button">Copy the link</button>
        </div>
    </div>
    <hr >
    <div class="text-center mb-5">
        <div class="title__text pt-0">
            Enter the email address of the person whom you would like to send the questions to
        </div>
        <div class="email__form">
            <input type="text" id="external-send-request-text" class="input input__large input__blue">  
            <button id="external-send-request" class="button primary__button medium__button">Send request</button>
        </div>
    </div>
</div>